import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { useAuth } from '../../Context/AuthContext';
import { Breadcrumb, Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { camelize } from '../../Util';

const Main = () => {
  const { onLogout, user, dbUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleDownloadCP58 = () => {
    if (window.confirm(`Download CP58?`)) {
      window.open(
        `http://127.0.0.1:5001/sk-srikandi/asia-southeast1/query-downloadSrikandiData?secret=QAoL5xN6Up`,
        // `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-srikandiCommissionSummary?secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  }
  return (
    <>
      {' '}
      {user ? (
        <Navbar
          style={{
            backgroundColor: 'var(--baseColor)',
            paddingTop: '0.5rem',
            paddingBottom: '0.5rem',
            boxShadow: 'rgb(0 0 0 / 20%) 0px 3px 8px 0px',
          }}
          sticky="top"
          expand="md"
        >
          <Container>
            {/* <Navbar.Brand onClick={() => navigate('/')}>SK Srikandi Backend</Navbar.Brand> */}
            <Navbar.Brand onClick={() => navigate('/')}>
              <img src="/main-logo.png" width="125px" height="auto" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link onClick={() => navigate('/')}>Home</Nav.Link>                
                <Nav.Link onClick={() => navigate('/srikandi')}>Srikandi</Nav.Link>
                
                <NavDropdown title="Sales" id="basic-nav-dropdown">
                  <NavDropdown.Item onClick={() => navigate('/sales')}>
                    Sales Pipeline
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => navigate('/daily-sales')}>
                    Daily Sales
                  </NavDropdown.Item>
                </NavDropdown>
                
                {/* <Nav.Link onClick={() => navigate('/sales')}>Sales</Nav.Link>
                <Nav.Link onClick={() => navigate('/daily-sales')}>Daily Sales</Nav.Link> */}
                {dbUser?.role === 'admin' ? (
                  <NavDropdown title="Commission" id="basic-nav-dropdown">
                    <NavDropdown.Item onClick={() => navigate('/commissions')}>
                      Report
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/commissions/settings')}>
                      Settings
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/extra-bonus')}>
                      Extra Bonus
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item onClick={() => navigate('/combo-product')}>
                      Combo Product
                    </NavDropdown.Item> */}
                    <NavDropdown.Item onClick={() => navigate('/product-commissions')}>
                      Product Commissions
                    </NavDropdown.Item>
                  </NavDropdown>
                ) : (
                  <Nav.Link onClick={() => navigate('/commissions')}>Commission</Nav.Link>
                )}
                {dbUser?.role === 'admin' ? (
                  <Nav.Link onClick={() => navigate('/others')}>Others</Nav.Link>    
                ) : null}
              </Nav>
              <Nav>
                <Navbar.Text>
                  Signed in as:
                  <button
                    onClick={() => user?.uid && navigate(`srikandi/${user.uid}/edit`)}
                    style={{
                      color: 'var(--accentColor)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  >
                    {user.email}
                  </button>
                </Navbar.Text>
                <Nav.Link onClick={() => onLogout && onLogout()}>Logout</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      ) : null}{' '}
      <Container>
        {' '}
        <div
          style={{
            fontSize: '13px',
          }}
        >
          <br></br>
          <br />{' '}
          {user ? (
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate('/')}>Home</Breadcrumb.Item>
              {/*  {location.pathname !== '/' ? <Breadcrumb.Item onClick={() => navigate('/srik
               * andi')}>Srikandi</Breadcrumb.Item>: null}
               */}
              {location.pathname !== '/'
                ? location.pathname.split('/').map((e, i, array) =>
                    e ? (
                      <Breadcrumb.Item href="../" key={e} active={array.length !== i + 1 + 1 + 1}>
                        {camelize(e)}
                      </Breadcrumb.Item>
                    ) : null,
                  )
                : null}
            </Breadcrumb>
          ) : null}
        </div>
        <Outlet />
      </Container>
    </>
  );
};

export default Main;
